export default class ChecklistCounters {
  total = 0;
  good = 0;
  caution = 0;
  bad = 0;
  answered = 0;
}
